// extracted by mini-css-extract-plugin
export default {"container":"qrscanner_container__J-fG1","canvas-rect":"qrscanner_canvas-rect__KuuPf"};